// Dispatcher over the model-test blueprint helpers so the quiz Add/Edit forms and the taker can
// treat TOEFL and IELTS uniformly. Both blueprint modules expose the same builder API
// (bucketsFor/bucketKey/buildBlueprint/bucketsFromBlueprint) — only the section config and the
// stored metadata.test_kind differ.
import * as toefl from './toeflBlueprint';
import * as ielts from './ieltsBlueprint';
import * as sat from './satBlueprint';

export const isModelTestLevel = (level) => level === 'TOEFL' || level === 'IELTS' || level === 'SAT';

export function blueprintFor(level) {
    if (level === 'SAT') {
        return {
            SECTIONS: sat.SAT_SECTIONS,
            bucketsFor: sat.bucketsFor,
            bucketKey: sat.bucketKey,
            buildBlueprint: sat.buildBlueprint,
            bucketsFromBlueprint: sat.bucketsFromBlueprint,
            testKind: 'sat_model_test',
        };
    }
    const isIelts = level === 'IELTS';
    const m = isIelts ? ielts : toefl;
    return {
        SECTIONS: isIelts ? ielts.IELTS_SECTIONS : toefl.TOEFL_SECTIONS,
        bucketsFor: m.bucketsFor,
        bucketKey: m.bucketKey,
        buildBlueprint: m.buildBlueprint,
        bucketsFromBlueprint: m.bucketsFromBlueprint,
        testKind: isIelts ? 'ielts_model_test' : 'toefl_model_test',
    };
}
